import useViewsSelector from "views/stores/useViewsSelector";
import { selectIsDirty } from "views/logic/slices/viewSelectors";
const useIsDirty = () => useViewsSelector(selectIsDirty);
export default useIsDirty;
